import React from "react";
import { Bar } from "react-chartjs-2";
import { CardWithLable, DropDown } from "@public/ui-toolkit";
import moment from "moment";

const options = {
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
};

const BarChart = ({
  chartData,
  dropDownData,
  onChangeBarChartData,
  optionKey,
}) => {
  const barChartData = {
    labels: chartData?.map((d) => moment(d?.date, "YYYY-MM-DD").format("ddd")),
    datasets: [
      {
        label: "Views",
        data: chartData?.map((c) => c?.count),
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };
  return (
    <>
      <CardWithLable
        title="Allocator Views"
        img="./assets/images/drag-icon.svg"
        alt="drag icon"
        dropDownWhiteBg={
          <DropDown
            type="!primary"
            dropDownData={dropDownData}
            defaultOptionName="Week"
            onChange={onChangeBarChartData}
            optionKey={optionKey}
          />
        }
      >
        <div className="hf-card2-body px-0 pb-0">
          <div className="hf-table">
            <Bar data={barChartData} options={options} />
          </div>
        </div>
      </CardWithLable>
    </>
  );
};

export default BarChart;
